import {getLanguageFromLocale} from './localization';

export default function loadLocaleData(locale) {
    const language = getLanguageFromLocale(locale);

    let intlLibPolyfills = [];
    let intlLangPolyfills = [];

    if (!Intl.PluralRules) {
        intlLibPolyfills.push(
            import(
                /* webpackMode: "eager" */ '@formatjs/intl-pluralrules/polyfill'
            )
        );
        intlLangPolyfills.push(
            import(`@formatjs/intl-pluralrules/dist/locale-data/${language}`)
        );
    }

    if (!Intl.RelativeTimeFormat) {
        intlLibPolyfills.push(
            import(
                /* webpackMode: "eager" */ '@formatjs/intl-relativetimeformat/polyfill'
            )
        );
        intlLangPolyfills.push(
            import(
                `@formatjs/intl-relativetimeformat/dist/locale-data/${language}`
            )
        );
    }

    if (intlLibPolyfills.length === 0 && intlLangPolyfills.length === 0)
        return Promise.resolve();
    return Promise.all(intlLibPolyfills).then(() =>
        Promise.all(intlLangPolyfills)
    );
}
